import { EmailApi } from '../api/apicollection';

function checkValues(input){
    return !(input === '' || input === undefined || input === null);
}
export default function ContactUsViewModel() {
    this.emailStatus = ko.observable('error-message');
    this.message = ko.observable();
    this.formType = ko.observable('contact-form');

    this.phone = ko.observable();
    this.facility = ko.observable();
    this.unitNumber = ko.observable();
    this.fullName = ko.observable();
    this.email = ko.observable();
    this.comments = ko.observable();

    this.contact = document.getElementById('contact-form');

    this.triggerContact = () => {
        this.formType('contact-form__popup');

        if (this.contact.hidden) {
            this.contact.removeAttribute('hidden');
            document.getElementById('contact__icon').classList.remove('fa-comment-alt');
            document.getElementById('contact__icon').classList.add('fa-times');

        } else {
            this.contact.setAttribute('hidden', 'hidden');
            document.getElementById('contact__icon').classList.add('fa-comment-alt');
            document.getElementById('contact__icon').classList.remove('fa-times');
        }
    }

    this.sendEmail = async  () => {

        if (checkValues(this.fullName()) && checkValues(this.email()) && checkValues(this.comments())) {
            let response = await EmailApi.sendEmail({
                "name": this.fullName(),
                "email": this.email(),
                "phone": this.phone(),
                "facility": this.facility(),
                "unitNumber": this.unitNumber(),
                "comments": this.comments()
            });

            if (response.data === true) {
                this.emailStatus('success-message');
                this.message("Thanks for the message. We'll get back to you as soon as we can.");
            } else {
                this.message(response.data);
            }
        }else{
            this.message("Full name, email and comments cannot be empty.");
        }
    }
};